export const closingFooter = {
  email: 'hey@laebel.co',
  /** Footer statement, top left — one entry per line */
  title: ['Let’s talk!'],
  copyright: 'Laebel © 2026 All rights reserved',
  links: [
    { label: 'Work', href: '#work' },
    { label: 'Services', href: '#services' },
    { label: 'Culture', href: '#culture' },
    { label: 'Clients', href: '#clients' },
  ],
  address: ['Laebel Co,', 'Dubai Silicon Oasis,', 'DDP, Building A1, Dubai,', 'United Arab Emirates'],
  legal: [
    { label: 'Imprint', href: '/legal#imprint' },
    { label: 'Cookies', href: '/legal#cookies' },
    { label: 'Privacy Policy', href: '/legal#privacy' },
    { label: 'Credits', href: '/legal#credits' },
  ],
};
